import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import AboutSection from "@/components/AboutSection";
import ProgramsSection from "@/components/ProgramsSection";
import WhyChooseSection from "@/components/WhyChooseSection";
import SafetySection from "@/components/SafetySection";
import InstitutionsSection from "@/components/InstitutionsSection";
import InquiryForm from "@/components/InquiryForm";
import FAQSection from "@/components/FAQSection";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <Header />
      <HeroSection />
      <ProgramsSection />
      <AboutSection />
      <WhyChooseSection />
      <SafetySection />
      <InstitutionsSection />
      <InquiryForm />
      <FAQSection />
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
